/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  resetPassword(id, password, passwordConfirmation) {
    return axios.patch(`${this.url}/${id}/reset_password`, {
      agent: {
        password,
        password_confirmation: passwordConfirmation,
      },
    });
  }
}

export default new Agents();
